module.exports = __webpack_public_path__ + "img/ga.ad4d7405.svg";